export const DragItemTypes = {
	OPTION: "option",
};
